var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,20L10,20c-0.2,0-0.5-0.1-0.6-0.3l-5.6-8.3c-0.8-1.2-1.2-2.6-1.2-4C2.6,3.3,5.9,0,10,0s7.4,3.3,7.4,7.4 c0,1.4-0.4,2.8-1.2,4l-5.6,8.3C10.5,19.9,10.2,20,10,20z M10,1.5c-3.2,0-5.9,2.6-5.9,5.9c0,1.1,0.3,2.2,0.9,3.2l4.9,7.3l5-7.4 c0.6-0.9,0.9-2,0.9-3.2C15.9,4.1,13.2,1.5,10,1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,11.3c-2.2,0-3.9-1.8-3.9-3.9S7.8,3.4,10,3.4s3.9,1.8,3.9,3.9S12.2,11.3,10,11.3z M10,4.9 C8.7,4.9,7.6,6,7.6,7.4S8.7,9.8,10,9.8s2.4-1.1,2.4-2.4S11.3,4.9,10,4.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.154854f8270b76c788aa2e42be1ba63b.svg";
export { ForwardRef as ReactComponent };